import { combineReducers, createReducer } from '@reduxjs/toolkit';
import * as actions from '../actions';
import initialState from '../store/initialState';

export const calcForm = createReducer(initialState.calcForm, builder => {
  builder
    .addCase(actions.setCalcSelectionsState, (state, { payload }) => ({
      ...state,
      [payload.name]: payload.value
    }))
    .addCase(actions.setCalcTermState, (state, { payload }) => ({
      ...state,
      term: payload.term,
      creditRate: payload.rate
    }))
    .addCase(actions.setCalcFirstPaymentState, (state, { payload }) => ({
      ...state,
      firstPayment: payload
    }))
    .addCase(actions.setCreditAmountState, (state, { payload }) => ({
      ...state,
      creditAmount: payload
    }))
    .addCase(actions.setEmptyCalcState, state => ({
      ...state,
      has_bill_of_sale: true,
      official_income: true,
      calc_user_name: '',
      calc_phone_number: ''
    }));
});

export const searchForm = createReducer(initialState.searchForm, builder => {
  builder
    .addCase(actions.switchTab, (state, { payload }) => ({
      ...state,
      currentTabId: payload
    }))
    .addCase(actions.setSearchSort, (state, { payload }) => ({
      ...state,
      currentSortType: payload
    }))
    .addCase(actions.showPopupHeader, state => ({
      ...state,
      'popup-header': true
    }))
    .addCase(actions.hidePopupHeader, state => ({
      ...state,
      'popup-header': false
    }))
    .addCase(actions.setCurrentCity, (state, { payload }) => ({
      ...state,
      currentCity: payload
    }))
    .addCase(actions.setSearchValues, (state, { payload }) => ({
      ...state,
      values: payload
    }))
    .addCase(
      actions.setLocationsResetButtonIsDisabled,
      (state, { payload }) => ({
        ...state,
        locationsResetButtonIsDisabled: payload
      })
    )
    .addCase(actions.setResetButtonIsDisabled, (state, { payload }) => ({
      ...state,
      resetButtonIsDisabled: payload
    }))
    .addCase(actions.setChosenLocationNames, (state, { payload }) => ({
      ...state,
      chosenLocationNames: payload
    }))
    .addCase(actions.setLocationIds, (state, { payload }) => ({
      ...state,
      locationIds: payload
    }))
    .addCase(actions.setCurrentState, (state, { payload }) => ({
      ...state,
      currentState: payload
    }))
    .addCase(actions.setIsLoadingResultByNumber, (state, { payload }) => ({
      ...state,
      isLoadingResultByNumber: payload
    }))
    .addCase(actions.setResultByNumber, (state, { payload }) => ({
      ...state,
      resultByNumber: payload
    }))
    .addCase(actions.setCategoryIds, (state, { payload }) => ({
      ...state,
      categoryIds: payload
    }));
});

export const authModal = createReducer(initialState.authModal, builder => {
  builder
    .addCase(actions.toggleAuthModal, (state, { payload }) => ({
      ...state,
      isVisible: typeof payload === 'boolean' ? payload : !state.isVisible
    }))
    .addCase(actions.setEmail, (state, { payload }) => ({
      ...state,
      email: payload
    }));
});

export const notification = createReducer(
  initialState.notification,
  builder => {
    builder
      .addCase(actions.setNotification, (state, { payload }) => ({
        ...state,
        ...payload
      }))
      .addCase(actions.closeNotification, state => ({
        ...state,
        isClosing: true
      }))
      .addCase(
        actions.clearNotificationMessage,
        () => initialState.notification
      );
  }
);

export const drawerUI = createReducer(initialState.drawerUI, builder => {
  builder.addCase(actions.toggleDrawer, (state, { payload }) => ({
    ...state,
    isVisible: typeof payload === 'boolean' ? payload : !state.isVisible
  }));
});

const errorUI = createReducer(initialState.errorUI, builder => {
  builder.addCase(actions.setError, (state, { payload }) => ({
    ...state,
    isError: payload
  }));
});

const blockerDetector = createReducer(initialState.blockerDetector, builder => {
  builder.addCase(actions.setBlockerDetector, (state, { payload }) => ({
    ...state,
    isDetected: payload
  }));
});

export const sideMenuModal = createReducer(
  initialState.sideMenuModal,
  builder => {
    builder.addCase(actions.toggleSideMenuModal, (state, { payload }) => ({
      ...state,
      isVisible: typeof payload === 'boolean' ? payload : !state.isVisible
    }));
  }
);

export const addNewItemModal = createReducer(
  initialState.addNewItemModal,
  builder => {
    builder
      .addCase(actions.toggleAddNewItemModal, (state, { payload }) => ({
        ...state,
        isVisible: typeof payload === 'boolean' ? payload : !state.isVisible
      }))
      .addCase(actions.toggleAuthWindow, (state, { payload }) => ({
        ...state,
        isOpenAuthWindow:
          typeof payload === 'boolean' ? payload : !state.isOpenAuthWindow
      }))
      .addCase(
        actions.setCreationResetButtonIsDisabled,
        (state, { payload }) => ({
          ...state,
          creationResetButtonIsDisabled: payload
        })
      )
      .addCase(actions.setIsBannedUser, (state, { payload }) => ({
        ...state,
        isBannedUser: payload
      }));
  }
);

export const promotionModalView = createReducer(
  initialState.promotionModalView,
  builder => {
    builder.addCase(actions.togglePromotionModalView, (state, { payload }) => ({
      ...state,
      isVisible: typeof payload === 'boolean' ? payload : !state.isVisible
    }));
  }
);

export const restoreAlertModal = createReducer(
  initialState.restoreAlertModal,
  builder => {
    builder.addCase(actions.toggleRestoreAlertModal, (state, { payload }) => ({
      ...state,
      isVisible: typeof payload === 'boolean' ? payload : !state.isVisible
    }));
  }
);

export const successPromotionModalView = createReducer(
  initialState.successPromotionModalView,
  builder => {
    builder
      .addCase(
        actions.openSuccessPromotionAlertModal,
        (state, { payload }) => ({
          ...state,
          isVisible: true,
          name: payload
        })
      )
      .addCase(actions.setSuccessPromotionItemData, (state, { payload }) => ({
        ...state,
        itemData: payload
      }));
  }
);

export const refetchModalData = createReducer(
  initialState.successPromotionModalView,
  builder => {
    builder.addCase(actions.toggleRefetchModalData, (state, { payload }) => ({
      shouldRefetch: payload
    }));
  }
);

export const failurePaymentModalView = createReducer(
  initialState.failurePaymentModalView,
  builder => {
    builder.addCase(
      actions.openFailurePaymentAlertModal,
      (state, { payload }) => ({
        isVisible: payload.isVisible,
        name: payload.name
      })
    );
  }
);

export const itemsBalanceModalView = createReducer(
  initialState.itemsBalanceModalView,
  builder => {
    builder.addCase(actions.openItemsBalanceModal, (state, { payload }) => ({
      isVisible: payload
    }));
  }
);

export const buyItemsModalView = createReducer(
  initialState.buyItemsModalView,
  builder => {
    builder.addCase(actions.openBuyItemsModal, (state, { payload }) => ({
      isVisible: payload
    }));
  }
);

export const walletPayModalView = createReducer(
  initialState.walletPayModalView,
  builder => {
    builder.addCase(actions.openWalletPayModal, (state, { payload }) => ({
      isVisible: payload
    }));
  }
);

export const terminalModalView = createReducer(
  initialState.terminalModalView,
  builder => {
    builder.addCase(actions.openTerminalModal, (state, { payload }) => ({
      isVisible: payload
    }));
  }
);

export const personalAccountModalView = createReducer(
  initialState.personalAccountModalView,
  builder => {
    builder.addCase(actions.openPersonalAccountModal, (state, { payload }) => ({
      isVisible: payload
    }));
  }
);

export const profilePromotionItemId = createReducer(
  initialState.profilePromotionItemId,
  builder => {
    builder.addCase(
      actions.setProfilePromotionItemId,
      (state, { payload }) => ({ profileItemId: payload })
    );
  }
);

export const profileEditSuccessMessage = createReducer(
  initialState.profileEditSuccessMessage,
  builder => {
    builder.addCase(
      actions.showProfileEditSuccessMessage,
      (state, { payload }) => ({ isVisible: payload })
    );
  }
);

export const profilePromotionItemsModalView = createReducer(
  initialState.profilePromotionItemsModalView,
  builder => {
    builder.addCase(
      actions.toggleProfilePromotionItemsModal,
      (state, { payload }) => ({ isVisible: payload })
    );
  }
);

export const packagePayModalView = createReducer(
  initialState.packagePayModalView,
  builder => {
    builder.addCase(actions.openPackagePayModal, (state, { payload }) => ({
      isVisible: payload
    }));
  }
);

export const successWebViewPaymentStatusModalView = createReducer(
  initialState.successWebviewPaymentStatusModalView,
  builder => {
    builder
      .addCase(
        actions.openSuccessWebViewPaymentStatusAlertModal,
        (state, { payload }) => ({ isVisible: true, payment: payload })
      )
      .addCase(actions.closeSuccessWebViewPaymentStatusAlertModal, () => ({
        isVisible: false
      }));
  }
);

export const failureWebViewPaymentStatusModalView = createReducer(
  initialState.failureWebviewPaymentStatusModalView,
  builder => {
    builder.addCase(
      actions.openFailureWebViewPaymentStatusAlertModal,
      (state, { payload }) => ({
        isVisible: payload.isVisible,
        type: payload.type
      })
    );
  }
);

export const replenishmentNotifications = createReducer(
  initialState.replenishmentNotifications,
  builder => {
    builder.addCase(
      actions.setReplenishmentNotifications,
      (state, { payload }) => payload
    );
  }
);

export const replenishmentNotificationsModal = createReducer(
  initialState.replenishmentNotificationsModal,
  builder => {
    builder.addCase(
      actions.toggleReplenishmentNotificationsModal,
      (state, { payload }) => ({
        ...state,
        isVisible: typeof payload === 'boolean' ? payload : !state.isVisible
      })
    );
  }
);

export const userCards = createReducer(initialState.userCards, builder => {
  builder.addCase(actions.setUserCardsState, (state, { payload }) => ({
    cardsList: payload
  }));
});

export const adriverBanner = createReducer(
  initialState.adriverBanner,
  builder => {
    builder.addCase(actions.setAdriverSelectedCity, (state, { payload }) => ({
      selectedCityName: payload
    }));
  }
);

export const currentItem = createReducer(initialState.currentItem, builder => {
  builder
    .addCase(actions.setCurrentItemAuthModalOpen, (state, { payload }) => ({
      ...state,
      isAuthModalOpen: payload
    }))
    .addCase(actions.setCurrentItem, (state, { payload }) => ({
      ...state,
      currentItem: payload
    }));
});

export const profile = createReducer(initialState.profile, builder => {
  builder
    .addCase(actions.setProfileTransfersModalVisible, (state, { payload }) => ({
      ...state,
      isTransferModalVisible: payload
    }))
    .addCase(actions.setProfileMenuModalVisible, (state, { payload }) => ({
      ...state,
      profileMenuModalIsVisible: payload
    }));
});

export default combineReducers({
  authModal,
  addNewItemModal,
  sideMenuModal,
  promotionModalView,
  restoreAlertModal,
  drawerUI,
  searchForm,
  errorUI,
  blockerDetector,
  calcForm,
  successPromotionModalView,
  refetchModalData,
  failurePaymentModalView,
  itemsBalanceModalView,
  buyItemsModalView,
  walletPayModalView,
  terminalModalView,
  personalAccountModalView,
  profilePromotionItemId,
  profilePromotionItemsModalView,
  profileEditSuccessMessage,
  packagePayModalView,
  successWebViewPaymentStatusModalView,
  failureWebViewPaymentStatusModalView,
  notification,
  replenishmentNotifications,
  replenishmentNotificationsModal,
  userCards,
  adriverBanner,
  currentItem,
  profile
});
